import React from 'react';
import I18n from 'app/i18n';

const MaintenanceStub = (): React.ReactElement => <div className="wrapper-stub wrapper-stub--maintenance">
    <div className="inner-stub">
        <span className="stub-icon"/>
        <h1>{I18n.t('stub_maintenance.title')}</h1>
        <div className="stub-text">
            <p>{I18n.t('stub_maintenance.text_1')}</p>
            <p>{I18n.t('stub_maintenance.text_2')}</p>
        </div>
    </div>
</div>;

export default MaintenanceStub;
